import { DateInput, ReadOnlyInput, TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { Checkbox, Divider, FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@material-ui/core';
import { Categorias } from 'app/components/Categorias';
import { SelectClienteCreatable, SelectVendedor } from 'app/components/Select';
import { Servicos } from 'app/components/Servicos';
import { calcularValorLiquidoComRetencoes } from 'app/main/venda/utils/retencaoLiquidoUtils';
import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { ContratoUtil } from '../../../store';
import ImovelRelacionado from './ImovelRelacionado';

const DadosContrato = ({
  values,
  handleChange,
  handleBlur,
  handleChangeServico,
  handleChangePeriodicidade,
  handleChangeVigenciaInicial,
  handleChangeValorPrimeiraCategoria,
  errors,
  retencaoAliquota,
}) => {
  const formik = useFormikContext();
  const [indexServicoSelecionado, setIndexServicoSelecionado] = useState();
  const [modalRetencaoAliquota, setModalRetencaoAliquota] = useState('');

  const modalRetencaoAliquotaFechado = modalRetencaoAliquota === '';
  useEffect(() => {
    calcularSubtotal();
    calcularValorTotal();

    const { categorias } = values;

    calcularDiferencaCategoriasValor(values?.valorTotal, categorias);
    // Reset controlado pelo gatilho acima; incluir o formulário/valores reiniciaria o
    // preenchimento enquanto o usuário edita.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.categorias, values.servicos, values.valorTotal, modalRetencaoAliquotaFechado]);

  const calcularSubtotal = () => {
    values.servicos.forEach((itemServico) => {
      if (itemServico.subtotal === undefined || itemServico.subtotal === null) {
        // Campo subtotal no form guarda o bruto; o líquido é exibido/calculado à parte.
        itemServico.subtotal = itemServico.valor;
      }
    });
  };

  const calcularValorTotal = () => {
    let valorTotal = 0;

    values.servicos.forEach((itemServico) => {
      const base = itemServico?.subtotal != null ? itemServico.subtotal : itemServico?.valor || 0;
      valorTotal += calcularValorLiquidoComRetencoes(base, itemServico?.servicoFiscal);
    });

    formik.setFieldValue('valorTotal', valorTotal);
  };

  const calcularDiferencaCategoriasValor = async (valorTotal, categorias) => {
    const { setFieldValue } = formik;

    let totalCategorias = 0;

    categorias.forEach((categoria, i) => {
      totalCategorias += categoria.valorBruto ? categoria.valorBruto : 0;
    });

    if (valorTotal === '') {
      valorTotal = 0;
    }

    setFieldValue('diferencaCategorias', valorTotal?.toFixed(2) - totalCategorias?.toFixed(2));
  };

  // RNE-498
  const handleChangeCliente = (event) => {
    handleChange(event);

    if (event?.target?.value?.tipoPessoa === 'ESTRANGEIRA') {
      const event = {
        target: {
          id: 'formaCobranca',
          value: '',
        },
      };
      handleChange(event);
    }

    // Preencher e-mail principal com o e-mail do cliente
    if (event.target.value?.emailPrincipal) {
      handleChange({ target: { id: 'emailsCliente[0].email', value: event.target.value?.emailPrincipal } });
    } else {
      handleChange({ target: { id: 'emailsCliente[0].email', value: '' } });
    }
  };

  const calcularPeriodoVigencia = (event) => {
    const vigenciaInicial = event.target.id === 'dataVigenciaInicial' ? event.target.value : values.dataVigenciaInicial;
    const vigenciaFinal = event.target.id === 'dataVigenciaFinal' ? event.target.value : values.dataVigenciaFinal;
    const periodicidade = event.target.id === 'periodicidade' ? event.target.value : values.periodicidade;
    const vigenciaIndeterminada =
      event.target.id === 'vigenciaIndeterminada' ? event.target.checked : values.vigenciaIndeterminada;
    const vigenciaInicialComPeriodicidadeAnual =
      event.target.id === 'dataVigenciaInicial' && values?.periodicidade === 'ANUAL' && !values?.vigenciaIndeterminada;
    const periodicidadeAnualComVigenciaInicialPreenchida =
      event.target.id === 'periodicidade' &&
      event.target.value === 'ANUAL' &&
      values?.dataVigenciaInicial !== null &&
      values?.dataVigenciaInicial !== undefined;
    const vigenciaInicialComVigenciaIndeterminada =
      event.target.id === 'dataVigenciaInicial' && values?.vigenciaIndeterminada;

    if (vigenciaInicialComPeriodicidadeAnual || periodicidadeAnualComVigenciaInicialPreenchida) {
      handleChange({
        target: {
          id: 'dataVigenciaFinal',
          value: ContratoUtil.calcularVigenciaFinal(vigenciaInicial, vigenciaIndeterminada, periodicidade),
        },
      });
    }

    if (event.target.id === 'periodicidade' && event.target.value === 'ANUAL' && values?.dataVigenciaInicial) {
      handleChangePeriodicidade(event);
      handleChange({
        target: {
          id: 'dataVigenciaFinal',
          value: ContratoUtil.calcularVigenciaFinal(vigenciaInicial, vigenciaIndeterminada, event.target.value),
        },
      });
    }

    if (event.target.id === 'periodicidade' && event.target.value === 'ANUAL') {
      handleChange({ target: { id: 'periodoVigencia', value: 'Anual' } });
    }

    if (
      (event.target.id === 'periodicidade' &&
        event.target.value === 'MENSAL' &&
        values?.dataVigenciaInicial &&
        values?.vigenciaIndeterminada) ||
      vigenciaInicialComVigenciaIndeterminada
    ) {
      handleChange({
        target: {
          id: 'dataVigenciaFinal',
          value: ContratoUtil.calcularVigenciaFinal(vigenciaInicial, vigenciaIndeterminada, periodicidade),
        },
      });
    }

    // RNE-497
    else if (vigenciaInicial && vigenciaFinal && periodicidade === 'MENSAL') {
      handleChange({
        target: { id: 'periodoVigencia', value: ContratoUtil.calcularPeriodoVigencia(vigenciaInicial, vigenciaFinal) },
      });
    } else if (event.target.id === 'periodicidade' && event.target.value === 'MENSAL') {
      handleChange({
        target: { id: 'periodoVigencia', value: '-' },
      });
    }
  };

  const handleChangePeriodoVigencia = (event) => {
    handleChange(event);
    calcularPeriodoVigencia(event);
    if (event.target.id === 'dataVigenciaInicial' || event.target.id === 'vigenciaIndeterminada') {
      handleChangeVigenciaInicial(event);
      const ev = {
        target: { id: 'reajusteAutomatico.mesBaseReajuste', value: event.target.value },
      };
      handleChange(ev);
    }
  };

  const handleChangeCategoriaValorBruto = (event, index) => {
    if (event.target.id === 'categorias[0].valorBruto') {
      handleChangeValorPrimeiraCategoria(event);
    } else {
      handleChange(event);
    }

    if (!values?.possuiCobrancaGerada) {
      const e = {
        target: {
          id: `categorias[${index}].valorBrutoContratado`,
          value: event.target.value,
        },
      };
      handleChange(e);
    }
  };

  useEffect(() => {
    atualizarValorTotal();
    // A função é recriada a cada render; incluí-la reexecutaria a busca em loop.
    // O efeito depende apenas do gatilho listado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.categorias]);

  const atualizarValorTotal = () => {
    let valorTotal = 0;
    values.categorias.forEach((categoria) => {
      if (categoria.valorBruto) {
        valorTotal += categoria.valorBruto;
      }
    });
    if ((!values?.possuiCobrancaGerada && values?.valor === values?.valorContratado) || !values?.id) {
      const event = {
        target: {
          id: `valorContratado`,
          value: valorTotal,
        },
      };
      handleChange(event);
    }
    const event = {
      target: {
        id: `valor`,
        value: valorTotal,
      },
    };
    handleChange(event);
  };

  const handlerRetencaoAliquota = (index) => {
    setIndexServicoSelecionado(index);
    setModalRetencaoAliquota('retencaoAliquota');
  };

  const handleVigenciaIndeterminada = (e) => {
    handleChange(e);
    if (values?.periodicidade === 'MENSAL' && !e.target.checked) {
      handleChange({
        target: {
          id: 'dataVigenciaFinal',
          value: undefined,
        },
      });
    } else if (values?.dataVigenciaInicial) {
      handleChange({
        target: {
          id: 'dataVigenciaFinal',
          value: ContratoUtil.calcularVigenciaFinal(
            values?.dataVigenciaInicial,
            e.target.checked,
            values?.periodicidade
          ),
        },
      });
    }

    if (!e.target.checked && values?.periodicidade === 'ANUAL' && values?.dataVigenciaInicial) {
      handleChange({ target: { id: 'periodoVigencia', value: 'Anual' } });
    }
  };

  const calcularDiferencaCategorias = (event, index = -1) => {
    const {
      values: { categorias, valorTotal },
      setFieldValue,
    } = formik;

    let totalCategorias = 0;

    categorias.forEach((categoria, i) => {
      if (index !== i) {
        totalCategorias += categoria.valorBruto ? categoria.valorBruto : 0;
      } else {
        totalCategorias += event.target.value ? event.target.value : 0;
      }
    });

    setFieldValue('diferencaCategorias', valorTotal?.toFixed(2) - totalCategorias?.toFixed(2));
  };

  return (
    <Grid container spacing={3} className="mt-16 mb-16">
      <Grid item xs={2}>
        <ReadOnlyInput
          id="identificador"
          label="Identificador"
          value={values?.identificador?.toString().padStart(3, '0')}
        />
      </Grid>
      <Grid item xs={6}>
        <SelectClienteCreatable
          id="cliente"
          label="Cliente"
          required
          onChange={handleChangeCliente}
          onBlur={handleBlur}
          value={values?.cliente}
          error={errors?.cliente}
          touched={!!errors?.cliente}
          autoFocus
          disabled={values?.id || values?.possuiCobrancaBaixadaOuRemessaGerada || values?.possuiNotaTransmitida}
          maxLength={100}
        />
      </Grid>
      <Grid item xs={4}>
        <SelectVendedor
          id="vendedor"
          fullWidth
          label="Vendedor"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values?.vendedor}
          disabled={values?.possuiCobrancaBaixadaOuRemessaGerada || values?.possuiNotaTransmitida}
        />
      </Grid>
      <Grid item xs={2}>
        <SelectInput
          id="periodicidade"
          name="periodicidade"
          label="Periodicidade"
          labelId="periodicidade"
          onChange={handleChangePeriodoVigencia}
          onBlur={handleBlur}
          value={values?.periodicidade}
          disableClearable={true}
          disabled={values?.possuiCobrancaBaixadaOuRemessaGerada || values?.possuiNotaTransmitida}
          options={[
            { id: 'MENSAL', title: 'Mensal' },
            { id: 'ANUAL', title: 'Anual' },
          ]}
        />
      </Grid>
      <Grid item xs={3}>
        <DateInput
          id="dataVigenciaInicial"
          name="dataVigenciaInicial"
          label="Vigência inicial"
          onChange={handleChangePeriodoVigencia}
          onBlur={handleBlur}
          value={values?.dataVigenciaInicial}
          error={errors.dataVigenciaInicial}
          helperText={errors.dataVigenciaInicial}
          touched={!!errors.dataVigenciaInicial}
          required
          fullWidth
          variant="outlined"
          disabled={values?.possuiCobrancaBaixadaOuRemessaGerada || values?.possuiNotaTransmitida}
        />
      </Grid>
      <Grid item xs={3}>
        <DateInput
          id="dataVigenciaFinal"
          name="dataVigenciaFinal"
          label="Vigência Final"
          onChange={handleChangePeriodoVigencia}
          onBlur={handleBlur}
          value={values?.dataVigenciaFinal}
          error={errors.dataVigenciaFinal && values?.periodicidade !== 'ANUAL'}
          helperText={errors.dataVigenciaFinal}
          touched={!!errors.dataVigenciaFinal}
          required={values?.periodicidade !== 'ANUAL'}
          fullWidth
          variant="outlined"
          disabled={values?.vigenciaIndeterminada || values?.periodicidade === 'ANUAL'}
        />
      </Grid>
      <Grid item xs={2}>
        <ReadOnlyInput
          id="periodoVigencia"
          label="Período total"
          value={values?.vigenciaIndeterminada ? '-' : values?.periodoVigencia}
        />
      </Grid>
      <Grid item xs={2}>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              id="vigenciaIndeterminada"
              name="vigenciaIndeterminada"
              value={values?.vigenciaIndeterminada}
              checked={values?.vigenciaIndeterminada}
              onChange={handleVigenciaIndeterminada}
              onBlur={handleBlur}
            />
          }
          label="Vigência indeterminada"
        />
      </Grid>

      <Servicos
        servicos={values?.servicos}
        handleChange={handleChangeServico}
        onBlur={handleBlur}
        disabled={values?.possuiCobrancaBaixadaOuRemessaGerada || values?.possuiNotaTransmitida}
        indexServicoSelecionado={indexServicoSelecionado}
        handlerRetencaoAliquota={handlerRetencaoAliquota}
        modalRetencaoAliquota={modalRetencaoAliquota}
        setModalRetencaoAliquota={setModalRetencaoAliquota}
        errors={errors}
        calcularSubtotal={calcularSubtotal}
      />

      <Categorias
        categorias={values?.categorias}
        handleChangeValorBruto={(event, index) => {
          handleChangeCategoriaValorBruto(event, index);
          calcularDiferencaCategorias(event, index);
        }}
        handleChange={handleChange}
        diferencaCategorias={values?.diferencaCategorias}
        handleBlur={handleBlur}
        disabledClasse={values?.possuiCobrancaBaixadaOuRemessaGerada || values?.possuiNotaTransmitida}
        errors={errors}
        natureza="RECEITA"
        showDiferenca
      />

      {values?._exigeImovel && (
        <ImovelRelacionado
          values={values}
          handleChange={handleChange}
          handleBlur={handleBlur}
          errors={errors}
        />
      )}

      <Grid item xs={12}>
        <span
          style={{
            fontSize: '15px',
            color: 'black',
            marginRight: '5px',
            fontWeight: '500',
          }}
        >
          Município da incidência
        </span>

        <Grid item>
          <FormControl>
            <RadioGroup
              id="municipioIncidencia"
              name="municipioIncidencia"
              onChange={handleChange}
              value={values?.municipioIncidencia}
              row
            >
              <FormControlLabel control={<Radio color="primary" />} value="PRESTADOR" label="Prestador" />
              <FormControlLabel control={<Radio color="primary" />} value="TOMADOR" label="Tomador" />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Divider style={{ backgroundColor: 'rgba(0, 0, 0, 0.50)' }} />
      </Grid>

      <Grid item xs={12} className="mt-16">
        <TextInput
          id="informacoesComplementares"
          name="informacoesComplementares"
          label="Informações Complementares"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values?.informacoesComplementares}
          maxLength={500}
          fullWidth
          multiline
          rows={3}
          variant="outlined"
        />
      </Grid>
    </Grid>
  );
};

export default DadosContrato;
